import type { ExcelGridFilteredEmptyBodyProps } from "../models/excel-grid-component-props.models";

export const ExcelGridFilteredEmptyBody = ({ columnCount, dataTest }: ExcelGridFilteredEmptyBodyProps) => (
  <tbody>
    <tr>
      <td
        colSpan={columnCount}
        className="border-greyscale-20 h-36 border-b px-4 text-left text-sm opacity-70 dark:border-gray-700"
        data-test={`${dataTest}-filtered-empty`}
      >
        <div className="sticky left-4 w-fit">No rows match the active filters.</div>
      </td>
    </tr>
  </tbody>
);
